<template>
  <div align="left" class="mt-2">
    <ServiceDialog
      v-if="openDialog"
      :openDialog="openDialog"
      :serviceDetails="activeItem"
      primaryColor="cyan"
      @closeServiceDialog="closeServiceDialog"
    />
    <v-card color="cyan darken-1">
      <div align="center">
        <v-icon size="60" class="no-italics" color="cyan darken-4"
          >tz-bi-damng</v-icon
        >
        <h2 class="cyan--text text--darken-4">Distribution and Payments</h2>
      </div>
      <v-card class="mx-auto" tile id="payment-integration">
        <v-list dense color="cyan lighten-1">
          <v-list-item-group v-model="selectedItem" color="green darken-4">
            <v-list-item
              v-for="(item, i) in distributionServices"
              @click="viewServiceDetails(item)"
              :key="i"
            >
              <v-list-item-icon>
                <v-icon
                  color="cyan darken-4"
                  size="35"
                  style="font-style: normal; font-weight: 500;"
                  >{{ item.icon }}</v-icon
                >
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="black--text text--darken-4"
                  v-text="item.title"
                ></v-list-item-title>
                <v-list-item-subtitle v-text="item.description">
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import ServiceDialog from "@/components/ServiceDialog.vue";
export default {
  components: { ServiceDialog },
  props: ["distributionServices"],
  data() {
    return {
      activeItem: null,
      selectedItem: 0,
      openDialog: false,
    };
  },
  methods: {
    viewServiceDetails(service) {
      this.activeItem = service;
      this.openDialog = true;
    },
    closeServiceDialog() {
      this.openDialog = false;
    },
  },
};
</script>
